import React from 'react';

// Types
import { Integration } from 'Shared/types/DataSource.type';
import { IntegrationSources } from 'Shared/constants/IntegrationsList.constants';

// Components
import IntegrationsLoading from './IntegrationsLoading';
import IntegrationsListItem from './IntegrationsListItem';

// Styles
import './IntegrationsList.scss';

export type FilterType = { surfaceAI?: boolean; showOnly?: IntegrationSources[] };

type Props = {
  integrations: Array<Integration>;
  isLoading?: boolean;
  filters?: FilterType;
  redirectUrl?: string;
};

const IntegrationsList = ({ integrations, isLoading = false, filters, redirectUrl }: Props) => {
  const sortAlphabetically = list => {
    return list.sort((a, b) => {
      const textA = a.name.toUpperCase();
      const textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  };

  const mergedSources = sortAlphabetically(integrations);

  const baseClassName = 'IntegrationsList';

  if (isLoading) {
    return (
      <div className={baseClassName}>
        <IntegrationsLoading count={filters?.showOnly?.length} />
      </div>
    );
  }

  return (
    <div className={baseClassName}>
      {mergedSources.map(integration => (
        <IntegrationsListItem
          key={integration.slug}
          integration={integration}
          classnames={`${baseClassName}__integration`}
          filters={filters}
          redirectUrl={redirectUrl}
        />
      ))}
    </div>
  );
};

export default IntegrationsList;
